import { inject, injectable } from 'inversify';
import { CustomerChatbotDependencyTypes } from '@client/feature/customer-chatbots/customer-chatbot.dependency-types';
import type { CustomerChatbotApiService } from '@client/feature/customer-chatbots/data/service/customer-chatbot.api-service';
import type { CustomerChatbotVisitorIdentificationApiDataTransformer } from '@client/feature/customer-chatbots/data/transformer/customer-chatbot-visitor-identification.api-data-transformer';
import type { CustomerChatbotRepositoryInterface } from '@client/feature/customer-chatbots/domain/repository/customer-chatbot.repository';
import type { CustomerChatbotVisitorIdentification } from '@client/feature/customer-chatbots/domain/type/customer-chatbot-visitor-identification.type';
import { dispatchAuthenticationRequiredOnApiError } from '@shared/common/network/data/service/dispatch-authentication-required-on-api-error.service';

@injectable()
export class CustomerChatbotRepository implements CustomerChatbotRepositoryInterface {
  public constructor(
    @inject(CustomerChatbotDependencyTypes.CustomerChatbotApiService)
    private readonly customerChatbotApiService: CustomerChatbotApiService,
    @inject(CustomerChatbotDependencyTypes.CustomerChatbotVisitorIdentificationApiDataTransformer)
    private readonly visitorIdentificationApiDataTransformer: CustomerChatbotVisitorIdentificationApiDataTransformer,
  ) {}

  @dispatchAuthenticationRequiredOnApiError()
  public async login(): Promise<CustomerChatbotVisitorIdentification> {
    const response = await this.customerChatbotApiService.login();

    return this.visitorIdentificationApiDataTransformer.map(response.data);
  }
}
